import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  onEnter?: () => void;
}

const Input = ({ className, type, onEnter, ...props }: InputProps) => {
  function onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter' && onEnter) {
      onEnter();
    }
  }

  return (
    <div className='relative'>
      {props.icon && <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>{props.icon}</div>}
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-xs border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
          props.icon && 'pl-9',
        )}
        onKeyDown={onKeyDown}
        {...props}
      />
    </div>
  );
};
Input.displayName = 'Input';

export { Input };
